import PropTypes from 'prop-types';
import React from 'react';
import PieChart from 'react-minimal-pie-chart';
import { ChartColors } from '../../Includes/variables';
import './MinimalCircularChart.scss';

export default class MinimalCircularChart extends React.PureComponent {
    constructor(props) {
        super();
        this.state = {
            text: `${this.calculatePercentage(
                props.data[0].value,
                props.data
            )}%`,
            showToolTip: false,
        };
    }

    static propTypes = {
        data: PropTypes.array,
        chartDescription: PropTypes.string,
        colors: PropTypes.array,
    };

    static defaultProps = {
        colors: ChartColors,
        startAngle: 270,
        endAngle: 360,
        width: '130px',
        height: '130px',
    };

    calculatePercentage = (numerator, data) => {
        let sum = 0;
        data.forEach((obj) => (sum += obj.value));
        return Math.round((numerator / sum) * 100);
    };

    mouseOver = (event, data, dataIndex) => {
        const percentage = this.calculatePercentage(
            data[dataIndex].value,
            data
        );
        this.setState({
            text: `${percentage}% ${data[dataIndex].title}`,
            showToolTip: true,
        });
    };

    render() {
        const COLORS = this.props.colors;
        const data = this.props.data.map((item, idx) => {
            let cellColor = COLORS[idx];
            return {
                title: item.title,
                value: item.value,
                color: cellColor,
            };
        });
        let style = {};
        if (this.props.width) {
            style.width = this.props.width;
        }
        if (this.props.height) {
            style.height = this.props.height;
        }

        const chart = (
            <PieChart
                data={data}
                startAngle={this.props.startAngle}
                endAngle={this.props.endAngle}
                onMouseOver={(event, data, dataIndex) =>
                    this.mouseOver(event, data, dataIndex)
                }
            />
        );

        return (
            <div className="component-Charts-MinimalCircularChart">
                <div className="chart-width-container" style={style}>
                    <PieChart
                        data={data}
                        startAngle={this.props.startAngle}
                        endAngle={this.props.endAngle}
                        onMouseOver={(event, data, dataIndex) =>
                            this.mouseOver(event, data, dataIndex)
                        }
                    />
                </div>
                <div className={'chart-description'}>
                    <div className="number-display">{`${this.state.text}`}</div>
                    <div>{this.props.chartDescription}</div>
                </div>
            </div>
        );
    }
}
